var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import mixTraits from "../mixTraits";
import UrlTraits from "./UrlTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
import CatalogFunctionTraits from "./CatalogFunctionTraits";
let WebProcessingServiceCatalogFunctionTraits = (_dec = primitiveTrait({
  type: "boolean",
  name: "Execute with HTTP GET",
  description: "If true, sends a `GET` request to the Execute endpoint instead of the default `POST` request."
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "Store supported",
  description: "Indicates if the output can be stored by the WPS server and be accessed via a URL."
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "Status supported",
  description: "Indicates if Execute operation can return just the status information and perform the actual operation asynchronously."
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Identifier",
  description: "The identifier for the process"
}), _dec5 = primitiveTrait({
  type: "boolean",
  name: "Force convert results to v8",
  description: "If true, then all results will be converted from v7 to v8. If false, then the `result.version` string will be checked to see if conversion is necessary."
}), _class = class WebProcessingServiceCatalogFunctionTraits extends mixTraits(CatalogFunctionTraits, UrlTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "executeWithHttpGet", _descriptor, this);
    _initializerDefineProperty(this, "storeSupported", _descriptor2, this);
    _initializerDefineProperty(this, "statusSupported", _descriptor3, this);
    _initializerDefineProperty(this, "identifier", _descriptor4, this);
    _initializerDefineProperty(this, "forceConvertResultsToV8", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "executeWithHttpGet", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "storeSupported", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "statusSupported", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "identifier", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "forceConvertResultsToV8", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { WebProcessingServiceCatalogFunctionTraits as default };